import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout } from './components/layout/DefaultLayout';
import { HelpAndSupportPage } from './components/helpAndSupport/HelpAndSupportPage';
import { PlatformFunctionalityProvider } from '@jbhi-fi/components/src/PlatformFunctionality';
import { LinkComponentType } from '@jbhi-fi/components/src/PlatformFunctionality/types';
import { Link, BrowserRouter as Router, useHistory } from 'react-router-dom';

const HelpAndSupportWrapper = () => {
  const history = useHistory();
  return (
    <PlatformFunctionalityProvider linkComponent={Link as LinkComponentType} navigateFunction={history.push}>
      <HelpAndSupportPage />
    </PlatformFunctionalityProvider>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('help-support-page');
  if (container) {
    const root = createRoot(container);
    root.render(
      <BaseContentProvider>
        <DefaultLayout shouldHideCompareBar>
          <Router basename="/pages/help-and-support">
            <HelpAndSupportWrapper />
          </Router>
        </DefaultLayout>
      </BaseContentProvider>
    );
  }
});
